/* eslint-disable camelcase */
import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import {
    NewSplitBillingDiscriminationSnapshot,
    SplitBillingDiscriminationSnapshot,
} from '../../models/RentalPayment';
import api from '../api';

const updateSplitBillingDiscrimination = (
    splitId: string,
    contractId: string,
    key: string,
    data: NewSplitBillingDiscriminationSnapshot
): Promise<SplitBillingDiscriminationSnapshot> =>
    api.request<SplitBillingDiscriminationSnapshot>({
        method: 'PATCH',
        url: `${getBackVersion()}/agent/rental/contracts_rental/${contractId}/splits/${splitId}/split_billing_discriminations/${key}`,
        data: decamelizeKeys(data),
    });

export { updateSplitBillingDiscrimination };
